import type { RouteConfig } from 'vue-router'
import _ from 'lodash'

// 扩展 RouteConfig 类型
interface CustomRouteConfig extends RouteConfig {
  hidden?: boolean
  hiddenChildren?: boolean
  icon?: string
  children?: CustomRouteConfig[]
}

export const processLogAsyncRouterMap = (
  asyncRouterMap: CustomRouteConfig[],
) => {
  // 递归处理路由对象
  const processRoute = (route: CustomRouteConfig) => {
    // 处理当前路由
    const processed = _.pick(route, [
      'children',
      'component',
      'hiddenChildren',
      'hidden',
      'icon',
      'meta',
      'name',
      'path',
      'props',
    ]) as CustomRouteConfig

    processed.component = undefined

    // 递归处理子路由
    if (processed.children && processed.children.length > 0) {
      const filteredChildren = processed.children
        .map(processRoute)
        .filter((route): route is CustomRouteConfig => route !== null)
      processed.children =
        filteredChildren.length > 0 ? filteredChildren : undefined
    }

    return processed
  }
  const processedRoutes = asyncRouterMap.map(processRoute).filter(Boolean)
  console.log('打印异步路由', processedRoutes)
  console.log('打印异步路由', JSON.stringify(processedRoutes))
}
